import { Component, OnInit, Input, ViewChild, SimpleChanges } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormArray } from '@angular/forms';
import { environment as params } from 'src/environments/environment';
import * as moment from 'moment';
// import { InptAeropuertosGroupedComponent } from './components/aeropuertos-grouped/aeropuertos-grouped.component';
import { PassengersComponent } from '../inputs/passengers/passengers.component';
import { DatepickerComponent } from '../inputs/datepicker/datepicker.component';
import { saveDataSearchUtil } from 'src/app/core/services/utilities/saveDataSearchUtil.service';
import { Router } from '@angular/router';
import { WidgetService } from 'src/app/core/http/web/widget.service';
import { InptAeropuertosGroupedComponent } from './components/aeropuertos-grouped/aeropuertos-grouped.component';
@Component({
  selector: 'app-flights',
  templateUrl: './flights.component.html',
  styleUrls: ['./flights.component.scss', '../../../../../../../assets/css/arma-ruta.css']
})
export class FlightsComponent {
  @Input() public widgetData: any = null;
  @ViewChild('picker1') datePicker: DatepickerComponent;
  @ViewChild('picker2') datePicker2: DatepickerComponent;
  @ViewChild('sig') airportsCompo: InptAeropuertosGroupedComponent;
  @ViewChild('sig2') airportsCompo2: InptAeropuertosGroupedComponent;
  @ViewChild('sigtwo') passengers: PassengersComponent;
  @ViewChild('sigtwo2') passengers2: PassengersComponent;

  urlBaseMJ: any = (<any>params).api.mj;
  datepicker = ['20-06-2019', '24-06-2019'];
  public form: FormGroup;
  public formMultidestino: FormGroup;
  public formExtra: FormGroup;
  public passengersShow: any = false;
  private _flihtType = 'REDONDO';
  public singleDate = false;
  public submit: boolean;
  public initialDeparting: any;
  public set flihtType(value) {
    if (value === 'SENCILLO' || value === 'OPENJAW') {
      this.singleDate = true;
    } else {
      this.singleDate = false;
    }
    this._flihtType = value;
  }

  public get flihtType() {
    return this._flihtType;
  }

  public airportsGrp: any;
  public airLines: any;
  posicionesText = ['Primer', 'Segundo', 'Tercer', 'Cuarto', 'Quinto', 'Sexto'];
  public fCabina: any = null;
  public fStops: any = null;
  public inicio: any = new Date((new Date).setDate((new Date).getDate() + 2));

  constructor(
    private _f: FormBuilder,
    private saveInfoServ: saveDataSearchUtil,
    private router: Router,
    private wtServ: WidgetService,
  ) {
    this.form = this._f.group({
      date: [[], []],
      fOrigen: ['', [Validators.required]],
      fDestino: ['', [Validators.required]],
    });
    this.formExtra = this._f.group({
      fPasajeros: ['', [Validators.required]],
      fAerolinea: ['', []],
      fStudentFare: ['', []],
    });
    this.getAirportsGrp();
    this.getAirlines();
  }

  getAirportsGrp() {
    this.wtServ.getAirPortsGrouped().subscribe(
      data => {
        this.airportsGrp = data.data;
        this.buildForm();
      }
    );
  }

  getAirlines() {
    this.wtServ.getAirlines().subscribe(
      data => {
        this.airLines = data.data;
      }
    );
  }
  setValueDefault(): void {
    const def = 'Ciudad de méxico';
    if (this.airportsGrp !== undefined) {
      const find = this.airportsGrp[def] !== undefined ? this.airportsGrp[def][0] : '';
      this.form.controls.fOrigen.setValue(find);
      // this.fMultidestino.controls[0].get('mOrigen').setValue(find);
      this.initialDeparting = find;
    }
  }
  setValueFormMulti = value => {
    this.formMultidestino = value;
  }

  buildForm() {
    this.form.get('fOrigen').valueChanges.subscribe(value => {
      if (typeof value === 'object' && (this.airportsCompo2 || this.airportsCompo)) {
        this.saveInfoSearchFy('origen', value.name + ' (' + value.iata + ')');
        if (document.documentElement.clientWidth < 992) {
          if (this.airportsCompo2) {
            setTimeout(() => {
              this.airportsCompo2.checkClick();
              this.airportsCompo2.checkFocus();
            }, 500);
          }
        } else {
          if (this.airportsCompo) {
            this.airportsCompo.checkFocus();
          }
        }
      }
    });

    this.form.get('fDestino').valueChanges.subscribe(value => {
      if (typeof value === 'object') {
        this.saveInfoSearchFy('destino', value.name + ' (' + value.iata + ')');
        if (document.documentElement.clientWidth < 992) {
          this.datePicker2.openDatepicker();
        } else {
          this.datePicker.openDatepicker();
        }
      }
    });
    this.form.get('date').valueChanges.subscribe(value => {
      if (value[1] == 'Invalid date') {
        this.form.get('date').setValue([value[0]]);
      } else {
        if (value.length === 2) {
          this.saveInfoSearchFy('fecha_ida', value[0]);
          this.saveInfoSearchFy('fecha_vuelta', value[1]);
          setTimeout(() => {
            if (document.documentElement.clientWidth < 992) {
              this.passengers2.menuModal.openMenu();
            } else {
              this.passengers.menuModal.openMenu();
            }
          }, 1000);
        }
      }
    });
    this.setValueDefault();
  }

  updatePassengers(pasajeros) {
    this.formExtra.controls.fPasajeros.setValue(pasajeros);
  }

  updateAll(allData) {
    this.fCabina = allData.cabin;
    this.formExtra.controls.fAerolinea.setValue(allData.airline);
    this.formExtra.controls.fPasajeros.setValue(allData.passengers);
  }

  enviar() {
    console.log('Submited', this.form, this.form.invalid, this.flihtType);
    this.submit = true;
    let data: any = {};
    if (this.flihtType != 'OPENJAW') {
      if (this.form.invalid && this.formExtra.invalid) {
        return;
      }
      data = {
        ...this.form.value,
        ...this.formExtra.value
      };
      if (typeof data.fOrigen !== 'object' || typeof data.fDestino !== 'object') {
        return;
      }
      if ((this.flihtType == 'REDONDO' && data.date.length < 2) || (this.flihtType == 'REDONDO' && data.date.length == 0)) {
        return;
      }
      this.saveInfoSearchFy('pasengers', JSON.stringify(this.formExtra.value.fPasajeros));
      this.saveInfoSearchFy('escalas', this.fStops);
      this.saveInfoSearchFy('cabina', this.fCabina);
      this.saveInfoSearchFy('tipo', this.flihtType);
      if (typeof data.fAerolinea === 'object') {
        this.saveInfoSearchFy('aerolinea', data.fCabina);
      }
    } else {
      console.log('Arma tu ruta', this.formMultidestino.value, this.formExtra.value);
      if (this.formMultidestino.invalid) {
        return;
      }
      data = {
        ...this.formMultidestino.value,
        ...this.formExtra.value
      };
      const filtersInvalid = data.fMultidestino.filter(e => {
        if (e.mDate.length == 0) {
          return true;
        }
        if (typeof e.mOrigen !== 'object') {
          return true;
        }
        if (typeof e.mDestino !== 'object') {
          return true;
        }
        return false;
      });
      if (filtersInvalid.length > 0) {
        return;
      }
    }
    let URL = this.buildURL(data);
    this.router.navigate(['/motor/vuelos'], { queryParams: URL });

  }

  capitalizeEachWord(str) {
    return str.replace(/\w\S*/g, function (txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
  }

  saveInfoSearchFy(key, value) {
    this.saveInfoServ.saveData('Widget vuelos', key, value);
  }

  buildURL(data) {
    let
      PassengersADT,
      PassengersCHD,
      MaxStops,
      BookingClass,
      Airline;

    PassengersADT =
      data.fPasajeros.adult && data.fPasajeros.adult != ''
        ? data.fPasajeros.adult
        : 0;
    PassengersCHD =
      data.fPasajeros.child && data.fPasajeros.child != ''
        ? data.fPasajeros.child
        : 0;
    MaxStops = this.fStops > 3 ? 0 : this.fStops;

    switch (this.fCabina) {
      case 'Y':
        BookingClass = 'Economy'
        break;
      case 'S':
        BookingClass = 'PremiumEconomy'
        break;
      case 'C':
        BookingClass = 'Business'
        break;
      case 'J':
        BookingClass = 'PremiumBusiness'
        break;
      case 'F':
        BookingClass = 'First'
        break;
      case 'P':
        BookingClass = 'PremiumFirst'
        break;
    }
    Airline = data.fAerolinea.code;

    // Construir URL
    if (data.fMultidestino) {
      data.fMultidestino = data.fMultidestino.map(e => {
        return {
          Departing: e.mOrigen.iata,
          GoingTo: e.mDestino.iata,
          DateDeparting: e.mDate[0],
        };
      })
    }

    let urlBase = {
      Departing: data.fOrigen ? data.fOrigen.iata : undefined,
      GoingTo: data.fDestino ? data.fDestino.iata : undefined,
      TripType: this.flihtType,
      DateDeparting: data.date ? data.date[0] : undefined,
      DateReturn: data.date ? data.date.length > 1 ? data.date[1] : '' : '',
      PassengersADT: PassengersADT,
      PassengersCHD: PassengersCHD,
      MaxStops: MaxStops ? MaxStops : '3',
      BookingClass: BookingClass,
      Airline: Airline ? Airline : '',
      Multidestino: data.fMultidestino ? JSON.stringify(data.fMultidestino) : undefined
    };

    return urlBase;
  }

  changeFlihtType(status) {
    this.flihtType = status;
  }
  reverse() {
    let temp = JSON.parse(JSON.stringify(this.form.controls.fOrigen.value));

    this.form.controls.fOrigen.setValue(this.form.controls.fDestino.value);
    this.form.controls.fDestino.setValue(temp);
  }

  // multiReverse(mi) {
  //   let temp = JSON.parse(JSON.stringify(this.fMultidestino.controls[mi].get('mOrigen').value));

  //   this.fMultidestino.controls[mi].get('mOrigen').setValue(this.fMultidestino.controls[mi].get('mDestino').value);
  //   this.fMultidestino.controls[mi].get('mDestino').setValue(temp);
  // }
}
